export const PM_REQUEST_TAB_ID = 2
export const BC_REQUEST_TAB_ID = 1

export const REQUESTS_TABS = [
  {
    id: BC_REQUEST_TAB_ID,
    title: 'Business Consulting Dept'
  },
  {
    id: PM_REQUEST_TAB_ID,
    title: 'Project Management Dept'
  }
]



// WEBPACK FOOTER //
// ./src/constants/tabs/requestsTabs.js